import { render } from "./index.vue?vue&type=template&id=320f5ae8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/cookieAuthority/theme/PreferencePop/index.vue'],['render',render],['__file',"index.vue"]])

export default __exports__